import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import vueEs from '../lang/es';
import Vue from "vue";

Vue.use(Vuetify,
    {
        theme: {
            primary: '#828f98',
            secondary: '#1d1a15',
            accent: '#8c9eff',
            error: '#b71c1c'
        },
        lang: {
            locales: {vueEs},
            current: 'vueEs'
        }
    }
);


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetify.js